// extracted by mini-css-extract-plugin
module.exports = {"item":"EducationItem_item__KKHYC","institution":"EducationItem_institution__3hCbI","time":"EducationItem_time__2tQss","degree":"EducationItem_degree__3cGpn"};